import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

function Header() {
  return (
    <header className="header">
      <Link to="/courses" className="logo">
        PAI
      </Link>
      <nav>
        <a href="/courses">Начальный экран</a>
        <a href="/progress">Твой прогресс</a>
        <a href="/courses">Курсы</a>
        <a href="/practice_courses">Практика</a>
        <a href="mailto:nobigmotion@gmail.com">Поддержка</a>
      </nav>
    </header>
  );
}

export default Header;
